<template>
  <div class="container application">
    <div class="term-desc">
      <h2 class="mt-2">추가 결제 확인</h2>
      <h3 class="page-title mt-1">추가 결제 금액 : <span class="blue050">{{ formatNumber(additionalPrice.total) }}원 / 매월</span></h3>

      <div class="input-item">
        <div class="input-label">결제 수단</div>
        <div>{{ selectedCardLabel }}</div>
      </div>
      <div class="form-guide">
        <span class="blue050">등록하신 결제 수단으로 결제됩니다.</span>
      </div>
    </div>

    <div class="input-item">
      <div class="input-label">유의사항 안내</div>
      <div class="form-guide">
        - 이용 중 추가운전자 신규 등록 및 변경(월1회)이 가능하며, 인원 추가 시 이용요금이 추가될 수 있습니다.<br>
        - 추가 운전자 미등록 시 보험 적용에 제한이 있으니 반드시 등록 후 안전하게 차량을 이용해주시기 바랍니다.<br>
        - 결제가 완료된 후 추가 운전자 등록이 효력이 발생이 발생합니다.<br>
        - 결제 후 등록하신 추가 운전자의 휴대전화번호로 등록 안내 SMS가 전송됩니다.<br>
      </div>
    </div>

    <vs-row class="form-group submit mb-2">
      <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="bottom-button">
        <button
          type="submit"
          class="btn btn_lg btn_full btn_outline"
          @click.prevent="back"
        >
          이전
        </button>
      </vs-col>
      <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="bottom-button">
        <button
          type="submit"
          class="btn btn_lg btn_full"
          @click.prevent="next"
        >
          결제하기
        </button>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { find } from 'lodash';

export default {
  name: 'Step02',
  components: {},
  props: {
    data: {
      type: Array,
      default: () => ({}),
    },
    billingId: {
      type: Number,
      required: true,
    },
    additionalPrice: {
      type: Object,
      default: () => ({}),
    },
    userCards: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {};
  },
  computed: {
    userName() {
      return this.$store.state.user.name;
    },
    insurancePriceType() {
      return this.application.insurancePriceType;
    },
    selectedCardLabel() {
      const selected = find(this.userCards, (card) => (card.id === this.billingId));
      return selected.label;
    },
  },
  created() {
    this.$gtag.event('view', {
      page_name: 'plan_contract_extra_driver_2_check_payment',
      event_category: document.title,
      page_url: document.URL,
    });
  },
  methods: {
    next() {
      this.$emit('next');
    },
    back() {
      this.$emit('back');
    },
  },
};
</script>

<style lang="scss" scoped>
.input-item {
  &.mt-5 {
    margin: 50px 0 0 0;
  }
}

.price-details {
  padding: 5px 0 10px 0;
  &>li {
    padding: 0 0 5px 5px;
  }
}
.mod-label {
  opacity: 0.6;
  &:hover {
    color: #00B8FF;
  }
}
</style>
